"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQueryParams = exports.setIndexPageQueryParams = exports.setQueryParams = void 0;
const qs_1 = __importDefault(require("qs"));
const query_string_1 = __importDefault(require("query-string"));
const checkUserAgent_1 = require("../utils/checkUserAgent");
const cleanObject_1 = __importDefault(require("../utils/cleanObject"));
const localConsole_1 = __importDefault(require("../utils/localConsole"));
const setQueryParams = (urlParams, to) => {
    let params = {
        ...urlParams,
    };
    if (params.keyword && Array.isArray(params.keyword)) {
        const keywordArray = [...params.keyword];
        params.keyword = keywordArray
            .filter((str) => str !== "addr")
            .join(",");
    }
    const filteredParam = (0, cleanObject_1.default)(params);
    let deletedParam = {
        ...filteredParam,
        lat: null,
        lng: null,
        mode: null,
        token: null,
        region: null,
        size: null,
        dc_flag: null,
        page: null,
        order: filteredParam.order,
    };
    if (deletedParam && deletedParam.search_type) {
        delete deletedParam.search_type;
    }
    if (deletedParam && deletedParam.query) {
        const strObj = new String(deletedParam.query);
        if (strObj[strObj.length - 1] === " ") {
            deletedParam.query = deletedParam.query.trim();
        }
    }
    const resultParams = (0, cleanObject_1.default)(deletedParam);
    const replaceTo = to?.replace("/", "");
    localConsole_1.default?.log(replaceTo, "replaceTo");
    if (replaceTo === "list.dc" || replaceTo === "list") {
        return `/list.dc?${qs_1.default.stringify(resultParams || "") || ""}`;
    }
    if (replaceTo === "listmap") {
        return `/listmap?${qs_1.default.stringify(resultParams || "") || ""}`;
    }
    if (replaceTo === "search.dc" || replaceTo === "search") {
        return `/search.dc?${qs_1.default.stringify(resultParams || "") || ""}`;
    }
    return `/search.dc?${qs_1.default.stringify(resultParams || "") || ""}`;
};
exports.setQueryParams = setQueryParams;
const device = (0, checkUserAgent_1.checkDevice)();
const setIndexPageQueryParams = (params, to) => {
    const urlParam = {
        ...params,
    };
    if (urlParam.page) {
        delete urlParam.page;
    }
    if (urlParam.resultLocation) {
        delete urlParam.resultLocation;
    }
    if (urlParam.lat && urlParam.lng) {
        delete urlParam.lat;
        delete urlParam.lng;
    }
    if (urlParam.device) {
        delete urlParam.device;
    }
    if (urlParam.mode) {
        delete urlParam.mode;
    }
    if (urlParam.token) {
        delete urlParam.token;
    }
    if (params.shid && params.shid !== "") {
        urlParam.shid = params.shid;
    }
    if (params.region && params.region !== "") {
        urlParam.region = params.region;
    }
    if (to === "search" || (to === "search.dc" && device === "mobile")) {
        delete urlParam.region;
    }
    const indexResultParams = (0, cleanObject_1.default)(urlParam);
    if (to === "list.dc" || to === "list") {
        return `/list.dc?${qs_1.default.stringify(indexResultParams || "") || ""}`;
    }
    if (to === "search.dc" || to === "search") {
        return `/search.dc?${qs_1.default.stringify(indexResultParams || "") || ""}`;
    }
    return `/?${qs_1.default.stringify(indexResultParams || "") || ""}`;
};
exports.setIndexPageQueryParams = setIndexPageQueryParams;
const getQueryParams = () => {
    let query = query_string_1.default.parseUrl(window.location.href).query;
    if (localStorage.getItem("is_static") === "true" &&
        localStorage.getItem("static_query")) {
        const staticQuery = localStorage.getItem("static_query");
        if (staticQuery) {
            try {
                const parsedQuery = JSON.parse(staticQuery);
                if (typeof parsedQuery === "string") {
                    query = { ...query, query: parsedQuery };
                }
            }
            catch (e) {
                console.warn("static_query parsing 실패:", e);
            }
        }
    }
    else if (localStorage.getItem("is_static") === "false" &&
        localStorage.getItem("static_query")) {
        localStorage.removeItem("static_query");
    }
    const params = {
        ...query,
    };
    return params;
};
exports.getQueryParams = getQueryParams;
